(function() {
    'use strict';

    angular
        .module('LayoutBuilder')
        .directive('lbSidenavPanel', lbSidenavPanel);

    function lbSidenavPanel() {
        return {
            restrict: 'E',
            scope: {
                panel: '='
            },
            controller: lbSideNavCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/libraries/layoutBuilder/panels/sidenav'
        };
    }

    function lbSideNavCtrl(uriActiveLinkService) {
        var vm = this;

        this.$onInit = function() {
            vm.isNavItemActive = isNavItemActive;
        }

        function isNavItemActive(item) {
            return uriActiveLinkService(item.href) ? 'active' : '';
        }
    }
})();
